import Button from "@atlaskit/button/standard-button";
import React, { useCallback } from "react";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";

const ModalPrompt = (props) => {
  const closeModal = useCallback(() => props.setOpen(false), []);

  return (
    <div>
      <ModalTransition>
        {props.isOpen && (
          <Modal onClose={closeModal}>
            <ModalHeader>
              <ModalTitle>{props.modalTitle}</ModalTitle>
            </ModalHeader>
            <ModalBody>{props.modalBody}</ModalBody>
            <ModalFooter>
              <Button appearance="subtle" onClick={() => props.setOpen(false)}>
                {props.modalTitle === "Job details" ? "Close" : "Cancel"}
              </Button>
              {props.primaryButtonName ? (
                <Button
                  appearance="primary"
                  autoFocus
                  onClick={props.primaryButtonAction}
                >
                  {props.primaryButtonName}
                </Button>
              ) : (
                ""
              )}
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </div>
  );
};

export default ModalPrompt;
